export default "__VITE_ASSET__2a0cb483__"